import { DEFAULT_CLIDS, PWA_APP_CLIDS } from '@/constants/general'
import type { ApiRequests } from '@/utils/requests/api-requests'

import type { DisableAdOrder, Order, PurchaseStatus } from '.'

const PORTAL_CONTEXT_CLIDS = [DEFAULT_CLIDS.direct, DEFAULT_CLIDS.directTest, PWA_APP_CLIDS.pwa]

type PurchasePaymentOrder = Order | DisableAdOrder

type ProcessPurchaseParams = {
    api: ApiRequests
    clid?: string
    order: PurchasePaymentOrder
}

export function processInGamePaymentPurchase({ api, clid, order }: ProcessPurchaseParams) {
    const { adPlacement, ...orderObj } = order
    const url = orderObj.type === 'disable-ad-order' ? '/api/v1/user/disable-ad' : undefined

    return processPurchaseOrder(api, orderObj, clid, url)
}

function processPurchaseOrder(api: ApiRequests, data: PurchasePaymentOrder, clid?: string, url?: string) {
    let body: string

    if (data.type === 'order') {
        const { gameHru, attributes, ...orderObject } = data
        const attributesWithContext = isPortalContextClid(clid) ? { ...attributes, context: 'portal' } : attributes
        body = JSON.stringify({ order: orderObject, gameHru, attributes: attributesWithContext })
    } else {
        const { amount, durationInDays, externalId, attributes, subscription } = data
        body = JSON.stringify({ order: { amount, durationInDays, externalId, attributes, subscription } })
    }

    if (url) {
        return api.request<PurchaseStatus>(url, { method: 'POST', body })
    }

    return api.signedRequest<PurchaseStatus>('/api/v1/in-game-payments/purchase/signed', { method: 'POST', body })
}

export function isPortalContextClid(clid?: string) {
    return Boolean(clid && PORTAL_CONTEXT_CLIDS.includes(clid))
}
